import React from 'react'
import { config } from 'config'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'

class PostCategoryTag extends React.Component {
    render () {
        let color = '#5386C6';
        if(this.props.name == "conf") {
            color = '#c04840';
        }
        if(this.props.name == "life") {
            color = '#4840c0';
        }

        return (
        <small style={{backgroundColor: color, lineHeight: "18px", padding: "0px", color: 'white', display: 'inline-block', width: "42px"}}>&nbsp;#{this.props.name}&nbsp;</small>
        )
    }
}

export default PostCategoryTag



// WEBPACK FOOTER //
// ../components/PostCategoryTag.js